import { FsCore } from '@t/fs-core'
import cleansedUserInputs from '@u/parse-calculator-inputs'

export const calculatorsState = (s: FsCore.State) => s.calculators

export const getCalculator = (s: FsCore.State, key: string) => calculatorsState(s)[key]

export const getCalculatorInputs = (s: FsCore.State, key: string) =>
  cleansedUserInputs(getCalculator(s, key)?.inputs || {})

export const getDefaultCalculator = (s: FsCore.State) => Object.values(calculatorsState(s))[0]
// Only use this if you know you only have one calculator on your page!
export const getDefaultCalculatorInputs = (s: FsCore.State) =>
  cleansedUserInputs(getDefaultCalculator(s)?.inputs || {})
